import { createSlice } from '@reduxjs/toolkit';
import {
  getAllAdminCampaigns,
  getAllAdminDatasets,
  getAllAdminSchedules,
} from 'features/admin-campaigns/async';
import { AdminCampaignsState } from 'features/admin-campaigns/types';
import {
  fulfilled,
  initialRequestState,
  pending,
  rejected,
  requestReducer,
} from 'features/shared/request';

export const initialState: AdminCampaignsState = {
  campaigns: {
    data: undefined,
    request: initialRequestState,
  },
  datasets: {
    data: undefined,
    request: initialRequestState,
  },
  schedules: {
    data: undefined,
    request: initialRequestState,
  },
};

const slice = createSlice({
  name: 'adminCampaigns',
  initialState,
  reducers: {
    resetAdminCampaigns(state) {
      state.campaigns = {
        data: undefined,
        request: initialRequestState,
      };
    },
    resetAdminDatasets(state) {
      state.datasets = {
        data: undefined,
        request: initialRequestState,
      };
    },
    resetAdminSchedules(state) {
      state.schedules = {
        data: undefined,
        request: initialRequestState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAllAdminCampaigns.fulfilled,
      (state, { meta, payload }) => {
        if (state.campaigns.request.id === meta.requestId) {
          state.campaigns.data = payload;
          state.campaigns.request = requestReducer(
            state.campaigns.request,
            fulfilled({ meta })
          );
        }
      }
    );

    builder.addCase(getAllAdminCampaigns.pending, (state, { meta }) => {
      state.campaigns.data = undefined;
      state.campaigns.request = requestReducer(
        state.campaigns.request,
        pending({ meta })
      );
    });

    builder.addCase(getAllAdminCampaigns.rejected, (state, { meta }) => {
      state.campaigns.data = undefined;
      state.campaigns.request = requestReducer(
        state.campaigns.request,
        rejected({ meta })
      );
    });

    builder.addCase(
      getAllAdminDatasets.fulfilled,
      (state, { meta, payload }) => {
        if (state.datasets.request.id === meta.requestId) {
          state.datasets.data = payload;
          state.datasets.request = requestReducer(
            state.datasets.request,
            fulfilled({ meta })
          );
        }
      }
    );

    builder.addCase(getAllAdminDatasets.pending, (state, { meta }) => {
      state.datasets.data = undefined;
      state.datasets.request = requestReducer(
        state.datasets.request,
        pending({ meta })
      );
    });

    builder.addCase(getAllAdminDatasets.rejected, (state, { meta }) => {
      state.datasets.data = undefined;
      state.datasets.request = requestReducer(
        state.datasets.request,
        rejected({ meta })
      );
    });

    builder.addCase(
      getAllAdminSchedules.fulfilled,
      (state, { meta, payload }) => {
        if (state.schedules.request.id === meta.requestId) {
          state.schedules.data = payload;
          state.schedules.request = requestReducer(
            state.schedules.request,
            fulfilled({ meta })
          );
        }
      }
    );

    builder.addCase(getAllAdminSchedules.pending, (state, { meta }) => {
      state.schedules.data = undefined;
      state.schedules.request = requestReducer(
        state.schedules.request,
        pending({ meta })
      );
    });

    builder.addCase(getAllAdminSchedules.rejected, (state, { meta }) => {
      state.schedules.data = undefined;
      state.schedules.request = requestReducer(
        state.schedules.request,
        rejected({ meta })
      );
    });
  },
});

export const { resetAdminCampaigns, resetAdminDatasets, resetAdminSchedules } =
  slice.actions;

const { reducer } = slice;

export default reducer;
